export const CLOUD_SCRIPTS: Record<string, (input: any) => Promise<boolean>> = {
  // Apply retention labels
  "2ea71bdd-b7f3-431a-b31f-c4d02b2601d6": async (vars) => {
    console.log("run script!! ", vars);
    return true;
  },
  // Remove access of untrusted internal users to Folder's
  "9a7b1734-755d-4963-a9c1-3e49cb46f15a": async (vars) => {
    console.log("run script!! ", vars);
    return true;
  },

  // Remove access of personal addresses to Folder's
  "2314d3a4-5c63-4785-8254-4c16254f1274": async (vars) => {
    console.log("run script!! ", vars);
    return true;
  },

  // Remove access of ghost external users to Folder's
  "f3f0ae0b-6c69-4975-95e2-1dcec692bd87": async (vars) => {
    console.log("run script!! ", vars);
    return true;
  },
  // Apply enrypthion labels on ghost files
  "2b74a629-f75a-43a6-8cde-41ce76344001": async (vars) => {
    console.log("run script!! ", vars);
    return true;
  },
};
